import api from 'api'
import {
  ADVISOR_CLIENT_PLANS_RECEIVED,
  ADVISOR_CLIENT_PLANS_UNLOADED
} from './types'

// redux actions
export const clientPlansReceived = plans => ({
  type: ADVISOR_CLIENT_PLANS_RECEIVED,
  data: plans
})

export const clientPlansDataUnload = () => ({
  type: ADVISOR_CLIENT_PLANS_UNLOADED
})

export const unloadClientPlans= () => dispatch => {
  dispatch(clientPlansDataUnload())
}

export const getClientPlans = () => dispatch => 
  api.bmc.advisor.getClientPlans().then(plans => {
    plans.forEach(plan => {
      plan.assessment = !plan.assessment ? {} : JSON.parse(plan.assessment)
    })    
    dispatch(clientPlansReceived(plans))})

export const editPlan = (data) => dispatch =>
  api.bmc.advisor.editPlan(data).then(plans => {
    plans.forEach(plan => {
      plan.assessment = !plan.assessment ? {} : JSON.parse(plan.assessment)
    })
    dispatch(clientPlansReceived(plans))})
